module.exports = __webpack_public_path__ + "img/曲静渊.b41f8a44.jpg";